/**
 * Composant de layout flexible pour les tableaux de charges
 * Place les tableaux côte à côte avec retour à la ligne automatique
 * Alignement en haut pour éviter les grands espaces vides
 */
function ChargesTablesGrid({ children }) {
  const styles = {
    container: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(600px, 1fr))',
      alignItems: 'start',
      gap: '2rem',
      width: '100%',
      padding: '0 2rem'
    }
  };

  return (
    <div style={styles.container}>
      {children}
    </div>
  );
}

export default ChargesTablesGrid;
